export default "__VITE_ASSET__0cVYLj$i__";